import { request } from "@/utils/request";

export function selectTemplateCodeApi(data) {
  return request({
    url: `/admin/templateCode/select`,
    method: "POST",
    data,
  });
}

export function addTemplateCodeApi(data) {
  return request({
    url: `/admin/templateCode/add`,
    method: "POST",
    data,
  });
}

export function updateTemplateCodeApi(data) {
  return request({
    url: `/admin/templateCode/update`,
    method: "POST",
    data,
  });
}

export function deleteTemplateCodeApi(data) {
  return request({
    url: `/admin/templateCode/delete`,
    method: "POST",
    data,
  });
}
